var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96064 0.556415L7.96064 6.52689C7.96064 7.05472 7.75096 7.56092 7.37773 7.93415C7.0045 8.30737 6.4983 8.51705 5.97048 8.51705L-5.21956e-07 8.51705L-8.69926e-08 18.4678C-6.39207e-08 18.9957 0.209677 19.5019 0.582904 19.8751C0.956131 20.2483 1.46234 20.458 1.99016 20.458L13.9311 20.458C14.4589 20.458 14.9651 20.2483 15.3384 19.8751C15.7116 19.5019 15.9213 18.9957 15.9213 18.4678L15.9213 2.54657C15.9213 2.01875 15.7116 1.51255 15.3384 1.13932C14.9651 0.766092 14.4589 0.556415 13.9311 0.556415L7.96064 0.556415ZM6.46802 1.05395L6.46802 6.52689C6.46802 6.65885 6.4156 6.7854 6.32229 6.87871C6.22898 6.97201 6.10243 7.02443 5.97048 7.02443L0.497539 7.02443L6.46802 1.05395Z",
    fill: "#273896"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/fileUploadIcon.20f40f6518601fe8e4c2d24b42cfc293.svg";
export { ForwardRef as ReactComponent };